export default "__VITE_ASSET__kbTIKTM9__"